const state = {
  list: [],
  guide: {},
  edit_guide: {}
};

const getters = {
  list: (state) => {
    return state.list || [];
  },
  guide: (state) => {
    return state.guide || {};
  },
  edit_guide: (state) => {
    return state.edit_guide || {};
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_GUIDE(state, item) {
    state.guide = item;
    state.edit_guide = item;
  },
  EDIT_GUIDE(state, item) {
    state.edit_guide = item;
  }
};

const actions = {
  resetList({ commit }) {
    commit('SET_LIST', []);
  },
  getList({ commit }, productId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(productId ? `guides/getForProduct?id=${productId}` : 'guides/getAll')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`guides/get?id=${id || 0}`)
        .then((response) => {
          commit('SET_GUIDE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  getEditorUrl({}, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`guides/getEditorUrl?id=${id}`)
        .then((response) => {
          resolve(response.data.url);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  set({ commit }, item) {
    commit('SET_GUIDE', item);
  },
  edit({ commit }, item) {
    commit('EDIT_GUIDE', item);
  },
  save({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('guides/save', item)
        .then((response) => {
          commit('SET_GUIDE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
